module.exports = __webpack_public_path__ + "media/18.3463d6fb.wav";